import React from 'react';
import _ from 'lodash';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input';

function FormPhoneDisplayField({ value, ...field }) {
    return <PhoneInput value={value} disabled={true} />
}

export default FormPhoneDisplayField